import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, createCachedGetAction } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { TermsAndConditionsVersion } from "./terms-and-conditions.model";

export const ACTION_PREFIX = "[Terms and Conditions]";
export const TERMS_AND_CONDITIONS_ACTION_TYPE = {
	getHistory: `${ACTION_PREFIX} Get History`,
	getHistorySuccess: `${ACTION_PREFIX} Get History Success`,
	getHistoryFail: `${ACTION_PREFIX} Get History Fail`,
	getLatestVersion: `${ACTION_PREFIX} Get Latest Version`,
	getLatestVersionSuccess: `${ACTION_PREFIX} Get Latest Version Success`,
	getLatestVersionFail: `${ACTION_PREFIX} Get Latest Version Fail`,
};

@Injectable({
	providedIn: "root",
})
export class TermsAndConditionsAction {
	getHistory(): Action {
		return createCachedGetAction(
			{
				type: TERMS_AND_CONDITIONS_ACTION_TYPE.getHistory,
			},
			{ cacheKey: `${TERMS_AND_CONDITIONS_ACTION_TYPE.getHistory}` }
		);
	}

	getHistorySuccess(content: TermsAndConditionsVersion[]): ActionWithPayload {
		return {
			type: TERMS_AND_CONDITIONS_ACTION_TYPE.getHistorySuccess,
			payload: content,
		};
	}

	getHistoryFail(error: AppError): ActionWithPayload {
		return {
			type: TERMS_AND_CONDITIONS_ACTION_TYPE.getHistoryFail,
			payload: error,
		};
	}

	getLatestVersion(): Action {
		return createCachedGetAction(
			{
				type: TERMS_AND_CONDITIONS_ACTION_TYPE.getLatestVersion,
			},
			{ cacheKey: `${TERMS_AND_CONDITIONS_ACTION_TYPE.getLatestVersion}` }
		);
	}

	getLatestVersionSuccess(content: TermsAndConditionsVersion): ActionWithPayload {
		return {
			type: TERMS_AND_CONDITIONS_ACTION_TYPE.getLatestVersionSuccess,
			payload: content,
		};
	}

	getLatestVersionFail(error: AppError): ActionWithPayload {
		return {
			type: TERMS_AND_CONDITIONS_ACTION_TYPE.getLatestVersionFail,
			payload: error,
		};
	}
}
